<template>
  <v-layout wrap class="home_styles">
    <v-flex class="stepper">
      <div
        class="step d-flex justify-center align-center"
        v-for="step in steppers"
        :key="step.step"
      >
        <v-avatar
          :class="currentStep === step.step ? 'step__active' : 'step__no_active'"
          :size="isDesktop ? '24' : '18'"
        >
          <v-icon size="12" color="white" v-if="currentStep > step.step">mdi-check</v-icon>
        </v-avatar>
        <p class="step__title">{{ $t(step.title) }}</p>
      </div>
    </v-flex>

    <step-one
      v-if="currentStep === 1"
      ref="StepOne"
      @isConverted="isConverted"
    />

    <step-two
      v-if="currentStep === 2"
      ref="StepTwo"
      :svgPath="svgPath"
      @getCroppedImage="getCroppedImage"
      @onNextStep="onNextStep"
      @onBackStep="onBackStep"
    />

    <step-three
      v-if="currentStep === 3"
      ref="StepThree"
      :img="cropImg"
      @setFabricImageId="setFabricImageId"
      @onNextStep="onNextStep"
      @onBackStep="onBackStep"
    />

    <step-four
      v-if="currentStep === 4"
      ref="StepFour"
      :fabricImageId="fabricImageId"
      @onBackStep="onBackStep"
      @backToStep1="onBackToFirstStep"
      @isDisabledBack="onDisabledBack"
      @setFabricImageId="setFabricImageId"
      @onDisabled="onDisabledNext"
    />

    <v-flex v-if="isDesktop" class="notes_table">
      <div class="notes_table__title">
        <div v-if="currentStep === 1">{{ $t('step-one.page-notes.title') }}</div>
        <div v-if="currentStep === 2">{{ $t('step-two.title') }}</div>
        <div v-if="currentStep === 3">{{ $t('step-three.title') }}</div>
        <div v-if="currentStep === 4">{{ $t('step-four.title-note') }}</div>
      </div>

      <div class="notes_table__subtitle my-2">
        <div v-if="currentStep === 1">{{ $t('step-one.page-notes.subtitle') }}</div>
        <div v-if="currentStep === 2">{{ $t('step-two.note') }}</div>
        <div v-if="currentStep === 3">{{ $t('step-three.note') }}</div>
        <div v-if="currentStep === 4" class="mb-2">{{ $t('step-four.note-part1') }}</div>
        <div v-if="currentStep === 4">
          <div>{{ $t('step-four.note-part2') }}</div>
          <div
            v-if="isHashQuery"
            class="mt-4"
          >
            {{ $t('step-four.hash-text.text') }}
            <a :href="linkToStart">{{ $t('step-four.hash-text.hear') }}</a>
            {{ $t('step-four.hash-text.it') }}.
          </div>
        </div>
      </div>

      <div v-if="currentStep === 1" class="notes_table__divider my-4"></div>

      <div v-if="currentStep === 1">
        <div class="d-flex flex-nowrap mt-5">
          <img alt="delivery" src="assets/icons/step-one/delivery.svg"/>
          <div class="notes_table__note">{{ $t('step-one.page-notes.delivery') }}</div>
        </div>
        <div class="d-flex flex-nowrap mt-5">
          <img alt="delivery" src="assets/icons/step-one/print.svg"/>
          <div class="notes_table__note">{{ $t('step-one.page-notes.print') }}</div>
        </div>
        <div class="d-flex flex-nowrap mt-5">
          <img alt="delivery" src="assets/icons/step-one/hand-made.svg"/>
          <div class="notes_table__note">{{ $t('step-one.page-notes.hand-made') }}</div>
        </div>
      </div>

      <div v-if="currentStep !== 1">
        <div class="d-flex justify-center flex-wrap mt-6">
          <v-btn
            class="primary_button button_back mb-3"
            @click="onBackStep"
            :disabled="isDisabledBack"
          >
            {{ $t('buttons.back') }}
          </v-btn>
          <v-btn
            class="primary_button"
            :disabled="isDisabledNext"
            @click="onNextStepWrapper"
          >
            <img
              v-if="currentStep === 4"
              class="mr-2"
              alt="basket"
              src="assets/icons/step-four/basket.svg"
            />
            {{ $t(currentStep === 4 ? 'step-four.shopping-button' : 'buttons.next') }}
          </v-btn>
          <div
            v-if="currentStep === 4"
            class="d-flex flex-nowrap align-center mt-2"
          >
            <img
              class="mr-2"
              alt="delivery"
              src="assets/icons/step-four/delivery.svg"
            />
            <p class="delivery_text">{{ $t('step-four.delivery') }}</p>
          </div>
        </div>
      </div>
    </v-flex>

    <starting-modal
      ref="StartingModal"
    />
  </v-layout>
</template>

<script>
import StepOne from '@/components/home/step-one-component'
import StepTwo from '@/components/home/step-two-component'
import StepThree from '@/components/home/step-three-component'
import StepFour from '@/components/home/step-four-component'
import StartingModal from '@/components/home/starting-modal'

const STEPPERS = [
  {
    step: 1,
    title: 'steps.first-title'
  },
  {
    step: 2,
    title: 'steps.second-title'
  },
  {
    step: 3,
    title: 'steps.third-title'
  },
  {
    step: 4,
    title: 'steps.fourth-title'
  },
]

export default {
  name: "HomePage",
  components: {
    'step-one': StepOne,
    'step-two': StepTwo,
    'step-three': StepThree,
    'step-four': StepFour,
    'starting-modal': StartingModal,
  },
  data() {
    return {
      steppers: STEPPERS,
      currentStep: 1,
      svgPath: null,
      cropImg: null,
      fabricImageId: null,
      isDisabledBack: false,
      isDisabledNext: false,
      isHashQuery: false,
    };
  },
  computed: {
    linkToStart() {
      return process.env.VUE_APP_LINK_TO_START ? process.env.VUE_APP_LINK_TO_START : '#'
    }
  },
  mounted() {
    if (this.$route.query.hash) {
      this.currentStep = 4
      this.isHashQuery = true
    } else {
      this.$refs.StartingModal.isModalOpen = true
    }
  },
  methods: {
    isConverted(imageId) {
      this.svgPath = this.getSvgPath(imageId)
      this.$store.dispatch('cropperData/setCropperHeight', null)
      this.$store.dispatch('cropperData/setCropperWidth', null)
      this.currentStep = 2
    },
    onBackToFirstStep() {
      this.currentStep = 1
    },
    onDisabledBack() {
      this.isDisabledBack = true
    },
    onDisabledNext(value) {
      this.isDisabledNext = value
    },
    onNextStep() {
      this.currentStep++
    },
    onBackStep() {
      this.isDisabledNext = false
      this.currentStep--
    },
    onNextStepWrapper() {
      if (this.currentStep === 1) {
        this.$store.dispatch('cropperData/setCropperHeight', null)
        this.$store.dispatch('cropperData/setCropperWidth', null)
        this.onNextStep()
      } else if (this.currentStep === 2) {
        this.$refs.StepTwo.onNextStep()
      } else if (this.currentStep === 3) {
        this.$refs.StepThree.onNextStep()
      } else if (this.currentStep === 4) {
        this.$refs.StepFour.onBuy()
      } else {
        this.onNextStep()
      }
    },
    getSvgPath(svgId) {
      return process.env.VUE_APP_CONVERT_IMAGE_SERVER_URL + '/returnImage.php?id=' + svgId
    },
    getCroppedImage(image) {
      this.cropImg = image
    },
    setFabricImageId(imageId) {
      this.fabricImageId = imageId
    }
  }
};
</script>
